import { useMutation, useQuery } from "@tanstack/react-query";
import {
  ExternalProvidersService,
  ExternalProvidersFindAllPayload,
} from "../services/externalProviders.service";
import { ExternalProviderPayload } from "../domain/externalProviders.interface";

export const useExternalProviders = (
  filters: ExternalProvidersFindAllPayload
) => {
  const {
    data: externalProviders,
    isLoading: isLoadingExternalProviders,
    isFetching: isFetchingExternalProviders,
    refetch: refetchExternalProviders,
  } = useQuery({
    queryKey: ["parca-external-providers-list"],
    queryFn: () => ExternalProvidersService.findAll(filters),
  });

  return {
    externalProviders,
    isLoadingExternalProviders,
    isFetchingExternalProviders,
    refetchExternalProviders,
  };
};

export const useCreateExternalProvider = () => {
  return useMutation({
    mutationFn: (payload: ExternalProviderPayload) =>
      ExternalProvidersService.createOne(payload),
  });
};

export const useUpdateExternalProvider = () => {
  return useMutation({
    mutationFn: ({
      id,
      payload,
    }: {
      id: string;
      payload: ExternalProviderPayload;
    }) => ExternalProvidersService.updateOne({ id, payload }),
  });
};

export const useArchiveExternalProvider = () => {
  return useMutation({
    mutationFn: (id: string) => ExternalProvidersService.archiveOne(id),
  });
};
